module.exports = __webpack_public_path__ + "img/sdk1.c4a73c32.png";